import { SimpleCartStatus } from '@/constants/cart';
import {
  createProduct2Qty,
  getUniqueProductId,
  simpleInfoCreateProduct2Qty,
  createAllCartInfoItems
} from '@/utils/business';
import { getJStype } from '@/utils/common/type';
import { AddPopup, PerchaseItemReq, SimpleItemInfo, TagInfo, ShippingThresholdInfo } from 'types/so';
import {
  ADD_CART,
  SUB_CART,
  SYNC_CART_INFO,
  SYNC_SIMPLE_CART_INFO,
  UPDATE_SIMPLE_CART,
  SYNC_TAG_INGO,
  SYNC_MAY_LIKE,
  SET_REFERRER,
  ADD_MULTIPLE,
  SET_REFERRER_TYPE,
  SYNC_ADD_POPUP,
  ALL_CART_DATA,
  SYNC_SHIPPING_THRESHOLD_DATA,
  SYNC_SELLER_CART_DATA,
  SYNC_SELLER_CARTS_DATA,
  SYNC_ACTIVED_VENDOR,
  SYNC_SIMPLE_ITEMS
} from './actions';

export type CartStateProp = {
  count?: number;
  simple?: any;
  items?: any;
  id2qty?: ObjectType;
  tagInfo?: TagInfo;
  sellerTagInfo?: AddPopup;
  shippingThresholdInfo?: ShippingThresholdInfo;
  sellerCartInfo?: any;
  simpleItems?: any[];
};

export const initState = {
  count: 0,
  simple: null,
  items: null,
  id2qty: null,
  tagInfo: null,
  allCartInfo: null,
  shippingThresholdInfo: null,
  sellerCartInfo: null,
  sellerCartsInfo: [],
  activedVender: '',
  simpleItems: []
};

const getTotal = (obj: ObjectType) => {
  if (!obj || getJStype(obj) !== 'object') return 0;
  const keys = Object.keys(obj);
  return keys.reduce((pre, cur) => pre + obj[cur], 0);
};

const getTotalFromSimple = (obj: any) => {
  if (!obj || getJStype(obj) !== 'object') return 0;
  const items: SimpleItemInfo[] = obj?.items || [];
  return items.reduce((pre, cur) => {
    if (cur?.status !== SimpleCartStatus.canceled && (cur.vendor_is_opened ?? true) && (cur?.quantity ?? 0) > 0) {
      return pre + cur?.quantity;
    } else {
      return pre;
    }
  }, 0);
};

export default function reducers(state: CartStateProp = initState, action) {
  const { payload } = action;
  switch (action.type) {
    case SYNC_SIMPLE_CART_INFO:
      return {
        ...state,
        count: getTotalFromSimple(payload),
        id2qty: simpleInfoCreateProduct2Qty(payload),
        simple: payload,
        simpleItems: updateItems(payload?.items, state)
      };
    case SYNC_CART_INFO:
      const _id2qty = createProduct2Qty(payload);
      return {
        ...state,
        count: getTotal(_id2qty),
        id2qty: _id2qty,
        items: payload
      };
    case UPDATE_SIMPLE_CART:
      const _simple = calcSimple(payload, state);
      return {
        ...state,
        count: getTotalFromSimple(_simple),
        id2qty: simpleInfoCreateProduct2Qty(_simple),
        simple: _simple,
        simpleItems: updateItems(_simple, state)
      };
    case ADD_CART:
      const cartItem: PerchaseItemReq = payload;
      const addUniqueId = getUniqueProductId(cartItem.product_id, cartItem.product_key);
      const id2qtyCopy = { ...state.id2qty };
      id2qtyCopy[addUniqueId] = cartItem.quantity;
      return {
        ...state,
        count: getTotal(id2qtyCopy),
        id2qty: id2qtyCopy
      };
    case SUB_CART:
      const subItem: PerchaseItemReq = payload;
      const subUniqueId = getUniqueProductId(subItem.product_id, subItem.product_key);
      const isDelete = state.id2qty.hasOwnProperty(subUniqueId) && subItem.quantity === 0;
      const subId2qtyCopy = { ...state.id2qty };
      if (isDelete) {
        delete subId2qtyCopy[subUniqueId];
      } else {
        subId2qtyCopy[subUniqueId] = subItem.quantity;
      }
      return {
        ...state,
        count: getTotal(subId2qtyCopy),
        id2qty: subId2qtyCopy
        // simple: simpleCopy
      };
    case SYNC_TAG_INGO:
      return {
        ...state,
        tagInfo: payload
      };
    case SYNC_MAY_LIKE:
      return {
        ...state,
        ymlInfo: payload.ymlInfo,
        ymlId: payload.ymlId
      };
    case SET_REFERRER:
      return {
        ...state,
        referrer: payload
      };
    case ADD_MULTIPLE:
      const addGoods: PerchaseItemReq[] = payload;
      //quantity是购物车商品全部数量
      const idsMap = addGoods?.reduce((pre, cur) => {
        const uniqueId = getUniqueProductId(cur.product_id, cur.product_key);
        pre[uniqueId] = cur.quantity;
        return pre;
      }, {});
      const allId2qty = { ...state.id2qty, ...idsMap };
      return {
        ...state,
        count: getTotal(allId2qty),
        id2qty: allId2qty
      };
    case SET_REFERRER_TYPE:
      return {
        ...state,
        referrerType: payload
      };
    case SYNC_ADD_POPUP:
      return {
        ...state,
        sellerTagInfo: payload
      };
    case ALL_CART_DATA:
      const newid2qty = createProduct2Qty(payload);
      const { reCalcAllCount } = payload;
      let allDataState = {
        ...state,
        allCartInfo: payload,
        id2qty: newid2qty,
        simpleItems: createAllCartInfoItems(payload)
      };
      if (reCalcAllCount) {
        allDataState.count = getTotal(newid2qty);
      }
      return allDataState;
    case SYNC_SHIPPING_THRESHOLD_DATA:
      return {
        ...state,
        shippingThresholdInfo: payload
      };
    case SYNC_SELLER_CART_DATA:
      return {
        ...state,
        sellerCartInfo: payload
      };
    case SYNC_SELLER_CARTS_DATA:
      return {
        ...state,
        sellerCartsInfo: payload
      };
    case SYNC_ACTIVED_VENDOR:
      return {
        ...state,
        activedVender: payload
      };
    case SYNC_SIMPLE_ITEMS:
      return {
        ...state,
        simpleItems: updateItems(payload, state)
      };
    default:
      return state;
  }
}

// 此方法仅使用更新购物车中已有此商品的情况，如果没有此商品需重新同步购物车
function calcSimple(infoArr: { product_id: number; quantity: number; product_key: string }[], state: CartStateProp) {
  const cloneSimple = JSON.parse(JSON.stringify(state.simple));
  const items = cloneSimple?.items;
  if (items && Array.isArray(items)) {
    const newItems = items.map(item => {
      const itemProductKey = item.product_key || '';
      infoArr.forEach(info => {
        const infoProductKey = info.product_key || '';
        if (
          getUniqueProductId(item.product_id, itemProductKey) === getUniqueProductId(info.product_id, infoProductKey)
        ) {
          item.quantity = info.quantity;
        }
      });
      return item;
    });
    // 当数量减到0时需要清除相应的商品
    const findDeleteItemIndex = newItems.findIndex(item => item.quantity === 0);
    if (findDeleteItemIndex !== -1) {
      newItems.splice(findDeleteItemIndex, 1);
    }
    cloneSimple.items = newItems;
  }
  return cloneSimple;
}

function updateItems(payload, state) {
  const simpleItems = JSON.parse(JSON.stringify(state?.simpleItems));
  payload?.forEach(item => {
    const hasDate = !!simpleItems?.filter(i => i.product_id === item.product_id || i.product_key === item.product_key)
      ?.length;
    if (hasDate) {
      const index = simpleItems?.findIndex(i => i.product_id === item.product_id || i.product_key === item.product_key);
      simpleItems[index] = item;
    } else {
      simpleItems?.push(item);
    }
  });

  const valid = simpleItems?.filter(item => item?.quantity > 0);
  return valid;
}
